import { Effect } from "effect";
import { MerklClient } from "../merkl-client";
import { KvClient } from "../kv-client";

export type UpdateMerklCampaignMeta = ReturnType<
  typeof updateMerklCampaignMeta
>;
export type UpdateMerklCampaignMetaSuccess =
  Effect.Effect.Success<UpdateMerklCampaignMeta>;
export type UpdateMerklCampaignMetaError =
  Effect.Effect.Error<UpdateMerklCampaignMeta>;
export type UpdateMerklCampaignMetaContext =
  Effect.Effect.Context<UpdateMerklCampaignMeta>;

export function updateMerklCampaignMeta() {
  return Effect.gen(function* () {
    const campaignMetaArray = yield* MerklClient.getCampaignMetaArray({
      activeOnly: false,
    });

    yield* KvClient.setMerklCampaignMeta(campaignMetaArray);
  });
}
